import { supabase } from '@/lib/supabase';
import type { SettledInvoice } from '@/lib/portalPaymentSettlement';

export async function loadInvoiceSettlementByPayToken(
  payToken: string,
): Promise<SettledInvoice | null> {
  const { data, error } = await supabase
    .from('invoices')
    .select('status, appointment_id')
    .eq('pay_token', payToken)
    .maybeSingle();

  if (error || !data) return null;
  return {
    status: data.status,
    appointment_id: data.appointment_id,
  };
}
